export const isFetching = state => state.portal.groupManager.fetching;
export const group = state => state.portal.groupManager.group;
export const groupEvent = state => state.portal.groupManager.event;
export const groupSettings = state => state.portal.groupManager || {};
export const cateringSettings = state =>
  state.portal.groupManager.event.catering;
export const error = state => state.portal.groupManager.error;
